import { defaultFill } from '../../../../utils/constants';
var muiPauseCircleOutline16 = {
    paths: [
        {
            path: 'M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 Z M6,5 C6.55228475,5 7,5.45097518 7,5.99077797 L7,10.009222 C7,10.5173285 6.61727982,10.9361019 6.11733256,10.9933343 L6,11 C5.44771525,11 5,10.5490248 5,10.009222 L5,5.99077797 C5,5.48267152 5.38272018,5.06389808 5.88266744,5.00666569 L6,5 Z M10,5 C10.5522847,5 11,5.45097518 11,5.99077797 L11,10.009222 C11,10.5173285 10.6172798,10.9361019 10.1173326,10.9933343 L10,11 C9.44771525,11 9,10.5490248 9,10.009222 L9,5.99077797 C9,5.48267152 9.38272018,5.06389808 9.88266744,5.00666569 L10,5 Z',
            fill: defaultFill,
        },
    ],
    title: 'Pause',
    width: 16,
    height: 16,
};
var muiPauseCircleOutline = {
    base: muiPauseCircleOutline16,
    smIcon: muiPauseCircleOutline16,
};
export { muiPauseCircleOutline };
//# sourceMappingURL=pauseCircleOutline.js.map